// NOTE: we can use a function to build a path to a page (see bodySchema for buttons)
// export const buildProductRoute = (auctionId, laneId, productId) =>
//   `/auction/${auctionId}/lane/${laneId}/product/${productId}`;

export const tableSettings = {
  searchFields: [
    { label: 'Lot Number', param: 'LotNumber' },
    { label: 'Stock Number', param: 'StockNumber' },
    { label: 'Product Name', param: 'ProductName', inputWidth: '400px' },
  ],
  pageSelectTitle: 'Products',
  initialSortColumn: 'lotNumber',
  standardStoreParams: [
    'pageNumber',
    'pageSize',
    'searchText',
    'sortColumn',
    'sortDirection',
    'mediaGalleryState',
  ],
  getMethods: (lane, auction) => {
    if (lane.id)
      return {
        name: 'lane',
        fn: lane.fn,
        args: ['laneID', ...tableSettings.standardStoreParams],
        dataToMerge: { laneID: lane.id },
      };

    if (auction.id)
      return {
        name: 'auction',
        fn: auction.fn,
        args: ['auctionID', ...tableSettings.standardStoreParams],
        dataToMerge: { auctionID: auction.id },
      };

    return null;
  },
};

const headerSchema = [
  { index: 1, value: '', text: 'Action', sort: false },
  { index: 2, value: 'url', text: 'Product Image', sort: false },
  { index: 3, value: 'product', text: 'Product', sort: true },
  {
    index: 4,
    value: 'lotNumber',
    text: 'Lot Number',
    sort: true,
    initialSort: true,
  },
  { index: 5, value: 'productState', text: 'Status', sort: true },
  { index: 6, value: 'bookValue', text: 'Book Value', sort: true },
  { index: 7, value: 'startPrice', text: 'Start Price', sort: true },
  { index: 8, value: 'miles', text: 'Miles', sort: true },
  { index: 9, value: 'score', text: 'Score', sort: true },
  { index: 10, value: 'location', text: 'Location', sort: true },
  { index: 11, value: 'bidderName', text: 'Bidder Name', sort: true },
  { index: 12, value: 'stockNumber', text: 'Stock Number', sort: true },
  {
    index: 13,
    value: 'highBidAmount',
    text: 'High Bid Amount',
    sort: true,
  },
  { index: 14, value: 'lane', text: 'Lane Name', sort: true },
];

const bodySchema = [
  {
    index: 1,
    value: ['auctionID', 'laneID', 'productID'],
    content: {
      type: 'buttons',
      value: [
        {
          text: 'Edit',
          icon: 'edit',
          //fn: buildProductRoute,
          //url: 'fn',
          //args: ['auctionID', 'laneID', 'productID'],
          url: [
            'auction',
            '[auctionID]',
            'lane',
            '[laneID]',
            'product',
            '[productID]',
          ],
          key: '[productID]',
        },
      ],
    },
  },
  {
    index: 2,
    value: 'url',
    content: {
      type: 'image',
      value: { alt: ['Lot #', '[lotNumber]', ': ', '[product]'] },
    },
  },
  { index: 3, value: 'product', content: { type: 'text', value: 'value' } },
  { index: 4, value: 'lotNumber', content: { type: 'text', value: 'value' } },
  {
    index: 5,
    value: 'productState',
    content: { type: 'text', value: 'value' },
    shaded: true,
  },
  {
    index: 6,
    value: 'bookValue',
    content: { type: 'text', value: 'value' },
    format: 'currency',
  },
  {
    index: 7,
    value: 'startPrice',
    content: { type: 'text', value: 'value' },
    format: 'currency',
  },
  { index: 8, value: 'miles', content: { type: 'text', value: 'value' } },
  { index: 9, value: 'score', content: { type: 'text', value: 'value' } },
  { index: 10, value: 'location', content: { type: 'text', value: 'value' } },
  { index: 11, value: 'bidderName', content: { type: 'text', value: 'value' } },
  {
    index: 12,
    value: 'stockNumber',
    content: { type: 'text', value: 'value' },
  },
  {
    index: 13,
    value: 'highBidAmount',
    content: { type: 'text', value: 'value' },
    format: 'currency',
  },
  { index: 14, value: 'lane', content: { type: 'text', value: 'value' } },
];

export const schema = {
  tableSettings,
  headerSchema,
  bodySchema,
  debugging: false,
};
